var _defs, _rect, _circle, _circle2, _circle3, _circle4, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _g, _g2, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWrittenExpression1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 400,
    viewBox: "0 0 800 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2196f3",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1565c0",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 2,
    stdDeviation: 5,
    floodColor: "#000",
    floodOpacity: 0.3
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 400,
    rx: 15,
    fill: "url(#bgGradient)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 80,
    r: 60,
    fill: "#ffffff",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 320,
    r: 80,
    fill: "#ffffff",
    fillOpacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 350,
    r: 40,
    fill: "#ffffff",
    fillOpacity: 0.05
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 100,
    r: 50,
    fill: "#ffffff",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 100,
    width: 300,
    height: 4,
    rx: 2,
    fill: "#ffffff",
    fillOpacity: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 120,
    width: 250,
    height: 4,
    rx: 2,
    fill: "#ffffff",
    fillOpacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 140,
    width: 280,
    height: 4,
    rx: 2,
    fill: "#ffffff",
    fillOpacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 160,
    width: 200,
    height: 4,
    rx: 2,
    fill: "#ffffff",
    fillOpacity: 0.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 180,
    width: 270,
    height: 4,
    rx: 2,
    fill: "#ffffff",
    fillOpacity: 0.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 200,
    width: 230,
    height: 4,
    rx: 2,
    fill: "#ffffff",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(120, 200)",
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 80,
    height: 100,
    rx: 5,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 20,
    width: 60,
    height: 3,
    rx: 1.5,
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 30,
    width: 50,
    height: 3,
    rx: 1.5,
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 40,
    width: 55,
    height: 3,
    rx: 1.5,
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 50,
    width: 40,
    height: 3,
    rx: 1.5,
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 60,
    width: 60,
    height: 3,
    rx: 1.5,
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 70,
    width: 45,
    height: 3,
    rx: 1.5,
    fill: "#2196f3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(650, 200) rotate(-45)",
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 15,
    height: 80,
    rx: 2,
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 15,0 15,15 0,15",
    fill: "#E91E63"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,80 15,80 7.5,95",
    fill: "#424242"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 300,
    fontFamily: "Arial, sans-serif",
    fontSize: 40,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "#ffffff",
    filter: "url(#shadow)"
  }, "\n    TCF CANADA\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 340,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: "normal",
    textAnchor: "middle",
    fill: "#ffffff",
    filter: "url(#shadow)"
  }, "\n    Expression \xC9crite\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrittenExpression1);
export default __webpack_public_path__ + "static/media/written-expression-1.257cc2529667c43cec1bc7db252c7d5c.svg";
export { ForwardRef as ReactComponent };